var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenSticker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#00c596;}.b{stroke:#fff;}.c,.d,.e{fill:#fff;}.c{font-size:7px;font-family:Impact;}.d,.e{font-size:5px;}.d{font-family:FontAwesome5Pro-Solid, 'Font Awesome 5 Pro';}.e{font-family:FontAwesome5Pro-Regular, 'Font Awesome 5 Pro';}.f{stroke:none;}.g{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.336)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0.336)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1.534 1.534)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 14.573,
    cy: 14.573,
    r: 14.573
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 14.573,
    cy: 14.573,
    r: 14.073
  })), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(14.077 26.379) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EASY")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.74 15.751) rotate(-30)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.813,
    y: 0
  }, "STAR")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(10.67 4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.813,
    y: 0
  }, "STAR")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(17.573 4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.813,
    y: 0
  }, "STAR"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSticker);
export default __webpack_public_path__ + "static/media/green-sticker.6fb41dff269b1fe00533c103ef7b170a.svg";
export { ForwardRef as ReactComponent };